import PaginationButtonRow from '@shared/components/core/button/PaginationButtonRow';
import SearchField from '@shared/components/core/search/SearchField';
import { StickyFooterStretch } from '@shared/components/core/structure/CommonBodyLayoutStyles';
import SplashLoader from '@shared/components/loading/SplashLoader';

import { CardStackWrap } from '@shared/components/core/card/CommonCardStyles';
import { useOrgProductFetching } from '@shared/hooks/useOrgProductFetching';
import useOrgProductSearch from '@shared/hooks/useOrgProductSearch';
import { useTranslation } from 'react-i18next';
import OrgProductCard from './OrgProductCard';
import OrgProductEmptyBanner from './OrgProductEmptyBanner';

export default function OrgProductPageContent() {
    const { t } = useTranslation();
    const { isLoading } = useOrgProductFetching(); //initialize
    const orgProductSearch = useOrgProductSearch(); //search

    const hasResults = orgProductSearch?.results.length > 0;
    if (isLoading) return <SplashLoader />;
    return (
        <>
            <SearchField
                value={orgProductSearch.searchQuery}
                onChange={(e) => orgProductSearch.handleSearchQueryChange(e.target.value)}
                onClear={() => orgProductSearch.handleSearchQueryChange('')}
            />
            {hasResults ? (
                <CardStackWrap>
                    {orgProductSearch.results.map((orgProduct) => (
                        <OrgProductCard orgProduct={orgProduct} key={orgProduct.id} />
                    ))}
                </CardStackWrap>
            ) : (
                <OrgProductEmptyBanner />
            )}
            <StickyFooterStretch
                $visuallyHide={
                    orgProductSearch.results.length == 0 ||
                    orgProductSearch.results.length < orgProductSearch.displayLimit
                }>
                <PaginationButtonRow
                    onNext={orgProductSearch.handleNext}
                    onPrevious={orgProductSearch.handlePrevious}
                    disableNext={!orgProductSearch.showNext}
                    disablePrevious={!orgProductSearch.showPrevious}
                />
            </StickyFooterStretch>
        </>
    );
}
